import { CellContext } from '@tanstack/react-table';
import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { splitPrice } from '@/utils/formatters.ts';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const moneyValueFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as MoneyValueDto | null;
  if (!value) return <EmptyValue />;

  const { main, secondary } = splitPrice(value.amount, value.currency);
  return (
    <>
      {main}
      <CellSecondary>{secondary}</CellSecondary>
    </>
  );
};
